import type { FullPostType } from '../factories/types';

export function getFullPostType(platform: string, postType: string, hasRecommendedGroup: boolean): FullPostType {
	return `${platform}${hasRecommendedGroup ? '_group' : ''}_${postType}` as FullPostType;
}

export function getFullPostTypeForTracking(platform: string, postType: string, hasRecommendedGroup: boolean): string {
	const fullPostType = getFullPostType(platform, postType, hasRecommendedGroup);

	if ((platform === 'reddit' || platform === 'facebook') && hasRecommendedGroup) {
		return `${platform}_group`;
	}
	return fullPostType;
}
